<template>
	<div
		class="flex w-12 h-12 items-center bg-purple-600 rounded-full fixed nav-link hover:bg-purple-500 z-50 shadow justify-center"
	>
		<router-link class="text-white text-lg" to="/"
			><font-awesome-icon icon="search"
		/></router-link>
	</div>
</template>

<script>
import {
	faSearch,
	faUserFriends,
	faCompactDisc
} from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faSearch, faUserFriends, faCompactDisc);
Vue.component('font-awesome-icon', FontAwesomeIcon);

export default {
	name: 'NavBar',
	components: {
		FontAwesomeIcon
	}
};
</script>
